/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Users_Credits_Desc_LabelInputs */

const en_admin_users_credits_desc_label = /** @type {(inputs: Admin_Users_Credits_Desc_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Description`)
};

const zh_admin_users_credits_desc_label = /** @type {(inputs: Admin_Users_Credits_Desc_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`备注`)
};

/**
* | output |
* | --- |
* | "Description" |
*
* @param {Admin_Users_Credits_Desc_LabelInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const admin_users_credits_desc_label = /** @type {((inputs?: Admin_Users_Credits_Desc_LabelInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Users_Credits_Desc_LabelInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_users_credits_desc_label(inputs)
	return zh_admin_users_credits_desc_label(inputs)
});
export { admin_users_credits_desc_label as "admin.users.credits_desc_label" }